<template>
  <app-layout class="dashboard tabs-container" centered>
    <template v-slot:header> </template>
    <template v-slot:body>
      <div class="container col-lg-7 col-sm-12">
        <v-img v-if="logoUrl" :src="logoUrl" class="home_logo" />
        <h1 class="text-center mb-4">{{ greeting }} {{ user.firstName }}</h1>
        <Permissioned section="dashboard">
          <DashboardNavigationItems
            v-if="showDashboardNavigationItems"
            permission="shortcut-menu"
          />
        </Permissioned>
        <Todos
          v-if="showTodos"
          :todos="todos"
          :isFetchingTodos="isFetchingTodos"
        />
        <Matches :matches="matches" :isFetchingMatches="isFetchingMatches" />
        <Permissioned section="dashboard">
          <Summary permission="activity" :permissions="permissions" />
        </Permissioned>
      </div>
    </template>
  </app-layout>
</template>

<script>
import appLayout from "@/components/common/base-layouts/AppLayout";
import Summary from "@/components/dashboard/Summary";
import DashboardNavigationItems from "@/components/dashboard/DashboardNavigationItems";
import Todos from "@/components/todos/Todos";
import {
  FETCH_EVENTS,
  FETCH_TODOS,
  FETCH_MATCHES
} from "@/store/modules/dashboard/action-types";
import { DASHBOARD_NAMESPACE } from "@/store/modules/dashboard";
import { createNamespacedHelpers, mapState } from "vuex";
import { size } from "lodash";
import Permissioned from "@/components/common/Permissioned";
import Matches from "@/components/dashboard/matches/Matches";

const dashboard = createNamespacedHelpers(DASHBOARD_NAMESPACE);

export default {
  title: "Home - Track",
  components: {
    appLayout,
    Summary,
    Todos,
    Permissioned,
    DashboardNavigationItems,
    Matches
  },
  async created() {
    this.fetchTodos(this.user.id);
    this.fetchMatches(this.user.id);
  },
  computed: {
    ...dashboard.mapState({
      todos: state => state.todos,
      isFetchingTodos: state => state.isFetchingTodos,
      matches: state => state.matches,
      isFetchingMatches: state => state.isFetchingMatches
    }),
    ...mapState("auth", {
      permissions: state => state.permissions,
      user: state => state.userData,
      logoUrl: state => state.logoUrl
    }),
    showTodos() {
      return size(this.todos);
    },
    greeting() {
      const date = new Date();
      const current_hour = date.getHours();
      if (current_hour < 12) {
        return "Good Morning";
      } else if (current_hour < 18) {
        return "Good Afternoon";
      } else {
        return "Good Evening";
      }
    },
    showDashboardNavigationItems() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    ...dashboard.mapActions({
      fetchEvents: FETCH_EVENTS,
      fetchTodos: FETCH_TODOS,
      fetchMatches: FETCH_MATCHES
    })
  }
};
</script>

<style lang="scss">
.dashboard {
  &__date {
    width: 386px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 10px;

    @media only screen and (max-width: $mobile-breakpoint - 1) {
      width: 100%;
    }
  }
}

.home_logo {
  margin: 0 auto 20px auto;
  max-width: 200px;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    height: 136.67px;
    max-width: 200px;
  }
}
</style>
